import React, { useState } from 'react';
import Swal from 'sweetalert2'
import $ from 'jquery';
function Student_Form() {
const [formData, setFormData] = useState({
  fullName: '',
  email: '',
  mobileNo: '',
  whatsapp: '',
  collegeName: '',
  studentYear: '',
  branch: '',
  domain: '',
  referral: '',
});

const [nameError, setNameError] = useState(" "); 
const [emailError, setEmailError] = useState("");
const [phoneError, setPhoneError] = useState("");
const [whatsappError, setWhatsappError] = useState("");
const [collegeError, setCollegeError] = useState("");
const [studentYearError, setStudentYearError] = useState("");
const [branchError, setBranchError] = useState("");
const [referralError, setReferralError] = useState("");



const handleInputChange = (event) => {
  const { name, value } = event.target;

  if (name === 'fullName') {
    if (!value || !/^[A-Za-z\s]+$/.test(value)) {
      setNameError(`Invalid name format.`);
    }  
    else {
      setNameError("");
    }
  }
  
  if (name === 'email') {
    if (!value || !/\S+@\S+\.\S+/.test(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  
  }

  if (name === 'mobileNo') {
    if (!value || !/^\d{10}$/.test(value)) {
      setPhoneError("Length Should be 10 Digit");
    } else {
      setPhoneError("");
    }
  }
  if (name === 'whatsapp') {
    if (!value || !/^\d{10}$/.test(value)) {
      setWhatsappError("Length Should be 10 Digit");
    } else {
      setWhatsappError("");
    }
  }
  if (name === 'collegeName') {
    if (!value || !/^[A-Za-z\s]+$/.test(value)) {
      setCollegeError(`Invalid College Name format.`);
    }  
    else {
      setCollegeError("");
    }
  }
  if (name === 'studentYear') {
    if (!value) {
      setStudentYearError("Please select a year.");
    } else {
      setStudentYearError("");
    }
  }
  
  if (name === 'branch') {
    if (!value || !/^[A-Za-z\s]+$/.test(value)) {
      setBranchError(`Invalid Branch Name format.`);
    }  
    else {
      setBranchError("");
    }
  }

  if (name === 'referral') {
    if (!value || !/^[A-Za-z\s]+$/.test(value)) {
      setReferralError("Invalid Referral format.");
    } else {
      setReferralError("");
    }
  }

  
  setFormData({
    ...formData,
    [name]: value,
  });
};


const handleSubmit = async(event) => {
  event.preventDefault();
  $.ajax({
    url: 'https://forms.internselite.net/register',
    type: 'POST',
    data: { fullName: formData.fullName,
      mobileNo: formData.email,
      email: formData.email,
      whatsapp: formData.whatsapp,
      collegeName: formData.collegeName,
      studentYear: formData.studentYear,
      branch: formData.branch,
      domain: formData.domain,
      referral: formData.referral
     },
    success: function (response) {
      Swal.fire({
        title: "Form Submitted!",
        text: "Thank you for your submission! Your form has been successfully received. Our counsellor will get back to you with in 24 hours.",
        icon: "success"
      });
        $('[name="fullName"]').val('');
        $('[name="mobileNo"]').val('');
        $('[name="email"]').val('');
        $('[name="whatsapp"]').val('');
        $('[name="collegeName"]').val('');
        $('[name="studentYear"]').val('');
        $('[name="branch"]').val('');
        $('[name="domain"]').val('');
        $('[name="referral"]').val('');
    },
    error: function (error) {
      console.error('Error:', error);
    }
});
};

return (
  <>
{/* -------------------Desktop Form------------------- */}
  <div className="App ">
  <form onSubmit={handleSubmit}>
  <div className='container'>
    <div className="form-group">
        <label htmlFor="username" className='mx-1 mb-2 contact_form'>Name:</label>
        <input
        className='py-2 px-2 Student_form_input'
        type="text"
        id="fullName"
        name="fullName"
        placeholder="Your answer"
        value={formData.fullName}
        onChange={handleInputChange}
        required
        />
        {nameError && <div className="error text-danger">{nameError}</div>}
    </div>
    </div>

    <div className='container'>
    <div className="form-group my-3">
      <label htmlFor="email" className='mx-1 mb-2 contact_form'>Email:</label>
      <input
        className='py-2 px-2 Student_form_input'
        type="email"
        id="email"
        name="email"
        placeholder="Your answer"
        value={formData.email}
        onChange={handleInputChange}
        required
      />
      {emailError && <div className="error text-danger">{emailError}</div>}
    </div>
    </div>

    <div className='container'>
    <div className="form-group my-3">
      <label htmlFor="contactNumber" className='mx-1 mb-2 contact_form'>Contact Number:</label>
      <input
        className='py-2 px-2 Student_form_input'
        type="tel"
        id="mobileNo"
        name="mobileNo"
        placeholder="Your answer"
        value={formData.mobileNo}
        onChange={handleInputChange}
        required
      />
      {phoneError && <div className="error text-danger">{phoneError}</div>}
    </div>
    </div>

    <div className='container'>
    <div className="form-group my-3">
      <label htmlFor="WhatsappNumber" className='mx-1 mb-2 contact_form'>Whatsapp Number:</label>
      <input
        className='py-2 px-2 Student_form_input'
        type="tel"
        id="whatsapp"
        name="whatsapp"
        placeholder="Your answer"
        value={formData.whatsapp}
        onChange={handleInputChange}
        required
      />
      {whatsappError && <div className="error text-danger">{whatsappError}</div>}
    </div>
    </div>

    <div className='container'>
    <div className="form-group my-3">
        <label htmlFor="CollegeName" className='mx-1 mb-2 contact_form'>College Name:</label>
        <input
        className='py-2 px-2 Student_form_input'
        type="text"
        id="collegeName"
        name="collegeName"
        placeholder="Your answer"
        value={formData.collegeName}
        onChange={handleInputChange}
        required
        />
      {collegeError && <div className="error text-danger">{collegeError}</div>}
    </div>
    </div>

    <div className='container'>
    <div className=" my-3">
    <div className="form-group">
      <label htmlFor="YearOfStudy" className='mx-1 mb-2 contact_form'>Year Of Study :</label>
      <select
        className='py-2 px-2 Student_form_select'
        id="studentYear"
        name="studentYear"
        value={formData.studentYear}
        onChange={handleInputChange}
        required
      >
        <option value="" disabled>Select a year...</option>
        <option value="1styear"> 1st year</option>
        <option value="2ndyear">2nd year</option>
        <option value="3rdyear">3rd year</option>
        <option value="4thyear">4th year</option>
        <option value="graduated">graduated</option>
      </select>
      {studentYearError && <div className="error text-danger">{studentYearError}</div>}
    </div>
    </div>
    </div>

    <div className='container'>
    <div className="form-group my-3">
      <label htmlFor="Branch/Department" className='mx-1 mb-2 contact_form'>Branch/Department:</label>
      <input
        className='py-2 px-2 Student_form_input'
        type="text"
        id="branch"
        name="branch"
        placeholder="Your answer"
        value={formData.branch}
        onChange={handleInputChange}
        required
      />
      {branchError && <div className="error text-danger">{branchError}</div>}
    </div>
    </div>

    <div className='container'>
    <div className=" my-3">
    <div className="form-group">
      <label htmlFor="DomainsOfInternship" className='mx-1 mb-2 contact_form'>Domains Of Internship:</label>
      <select
        className='py-2 px-2 Student_form_select'
        id="domain"
        name="domain"
        value={formData.domain}
        onChange={handleInputChange}
        required
        >
        <option value="">Select a Domain...</option>
        <option value="Android App Development">Android App Development</option>
        <option value="Artifical Inteligence">Artifical Inteligence </option>
        <option value="AR/VR">AR/VR</option>
        <option value="Autocad">Autocad</option>
        <option value="Bio Informatics">Bio Informatics</option>
        <option value="Business Analytics">Business Analytics</option>
        <option value="C, C++ With DSA">C, C++ With DSA</option>
        <option value="Car Design">Car Design</option>
        <option value="Cloud Computing">Cloud Computing</option>
        <option value="Cyber Security">Cyber Security</option>
        <option value="Data Science">Data Science</option>
        <option value="Digital Markeing & Marketing">Digital Markeing & Marketing</option>
        <option value="Embedded Systems">Embedded Systems</option>
        <option value="Finance">Finance</option>
        <option value="Full Stack Web Development">Full Stack Web Development</option>
        <option value="Generative Artificial Intelligence">Generative AI</option>
        <option value="Genetic Engineering">Genetic Engineering</option>
        <option value="Graphic Design">Graphic Design</option>
        <option value="Human Resources">Human Resources</option> 
        <option value ="HEV (Hybrid Electric Vehicle)">(HEV) Hybrid Electric Vehicle</option>
        <option value="IC Engine">IC Engine</option>
        <option value="Internet Of Things">Internet Of Things (IOT)</option> 
        <option value="Java">Java</option>
        <option value="Machine Learning With Python">Machine Learning With Python</option>
        <option value="Mern Stack">Mern Stack</option>
        <option value="Nanoscience Nanotechnology">Nanoscience Nanotechnology</option>
        <option value="Psychology">Psychology</option>
        <option value="Python">Python</option>
        <option value="Regulatory Affairs">Regulatory Affairs (In Pharma & Healthcare)</option>
        <option value="Robotics">Robotics</option>
        <option value="Stock Market">Stock Market</option> 
        <option value="Supply Chain Management">Supply Chain Management</option>
        <option value="UI/UX Design">UI/UX Design</option>
        <option value="VlSI Design">VlSI Design</option>   
        <option value="Web Development">Web Development</option>               
        </select>
    </div>
    </div>
    </div>
    
    
    <div className='container'>
      <div className="form-group my-3">
        <label htmlFor="AnyReferral" className='mx-1 mb-2 contact_form'>Any Referral Of Friends (Name & Contact Number):</label>
        <input
          className='py-2 px-2 Student_form_input'
          type="text"
          id="referral"
          name="referral"
          placeholder="Your answer"
          value={formData.referral}
          onChange={handleInputChange}
          required
        />
      {referralError && <div className="error text-danger">{referralError}</div>}
      </div>
    </div>
    
    <div className='container'>
      <div className="form-group my-3">
        <label htmlFor="BranchDepartment" className='mx-1 mb-2 contact_form fw-bold'>Offical Website:</label>
        <a href='https://internselite.com/' target='_blank'>https://internselite.com/</a>
      </div>
    </div>
    
    <div className='container'>
      <div className='row'>
        <div className="d-flex justify-content-center my-4">
          <input className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button" type="submit" value="Submit"/>
        </div>
      </div>
    </div>
  </form>
  </div>
  </>
);
}

export default Student_Form;